module.exports = "/banker.jpg?cf3be0";